import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Loader2, Mail } from "lucide-react";
import { toast } from "sonner";

export function SendEmailDialog({ open, onOpenChange, endpoint, docLabel, numero }) {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post(endpoint, { message });
      toast.success(`E-mail envoyé à ${data.to}`);
      setMessage("");
      onOpenChange(false);
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) setMessage(""); onOpenChange(o); }}>
      <DialogContent className="w-[95vw] max-w-lg">
        <DialogHeader>
          <DialogTitle>Envoyer par e-mail</DialogTitle>
          <DialogDescription>
            {docLabel} {numero} sera envoyé en pièce jointe PDF à l'adresse e-mail enregistrée du destinataire.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label>Message (optionnel)</Label>
          <Textarea
            data-testid="send-email-message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Ajoutez un mot d'accompagnement…"
            rows={4}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="send-email-cancel">Annuler</Button>
          <Button onClick={send} disabled={sending} data-testid="send-email-confirm">
            {sending ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Mail className="h-4 w-4 mr-2" />}Envoyer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
